import { render, staticRenderFns } from "./AuthSuccess.vue?vue&type=template&id=59e0c95c&scoped=true"
import script from "./AuthSuccess.vue?vue&type=script&lang=js"
export * from "./AuthSuccess.vue?vue&type=script&lang=js"
import style0 from "./AuthSuccess.vue?vue&type=style&index=0&id=59e0c95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e0c95c",
  null
  
)

export default component.exports